module.exports = __webpack_public_path__ + "resources/img/img_appen_data2_jp.a2b4bbeb6d10502a4c1381f31aad05d1.png";